import PropTypes from "prop-types"
import React, { useEffect } from "react"
import {
  Row,
  Col,
  // CardBody,
  // Card,
  Alert,
  // Container,
  Form,
  Input,
  FormFeedback,
  Label,
} from "reactstrap"

// Formik validation
import * as Yup from "yup"
import { useFormik } from "formik"
import SocialLinkUpdate from "./SocialLink/SocialLinkUpdate"

import { Link, useLocation, useNavigate } from "react-router-dom"
import withRouter from "../../components/Common/withRouter"

// import images
import logo from "assets/images/logo-dark.png"
import logolight from "assets/images/logo-light.png"
import logoLg from "assets/images/header-logo-lg.svg"
import { Bounce, toast } from "react-toastify"
import SocialLink from "./SocialLink/SocialLink"
import { post } from "../../api/axios"
import endpoints from "../../api/endpoints"
const Register = props => {
  document.title = " Register | Dock Tok"
  const navigate = useNavigate()
  const location = useLocation()
  const queryString = location.search
  const params = new URLSearchParams(queryString)
  const handleClick = () => {
    navigate("/admin")
  }

  // const dispatch = useDispatch()

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      email: "",
      password: "",
      firstName: "",
      lastName: "",
    },
    validationSchema: Yup.object({
      firstName: Yup.string().required("Please Enter Your First Name"),
      lastName: Yup.string().required("Please Enter Your Last Name"),
      email: Yup.string()
        .email("Please enter a valid email")
        .required("Please Enter Your Email"),
      password: Yup.string().required("Please Enter Your Password"),
    }),
    onSubmit: async values => {
      // dispatch(loginUser(values, props.router.navigate))
      const response = await post(endpoints.register, values)
      console.log("response", response?.data)
      if (response?.data?.success) {
        navigate("/verifyemail", {
          state: {
            email: values.email,
          },
        })
        toast.success(response?.data?.message, {
          position: "bottom-center",
          theme: "colored",
          transition: Bounce,
        })
      } else {
        const errorMessage = response?.response?.data?.error
        const formattedMessage = errorMessage?.includes("to be unique")
          ? "This email is already registered. Please log in or use a different email."
          : errorMessage

        toast.error(formattedMessage, {
          position: "bottom-center",
          theme: "colored",
          transition: Bounce,
        })
      }
    },
  })
  useEffect(() => {
    // dispatch(apiError(""))
    document.body.className = "authentication-bg"
    // remove classname when component will unmount

    return function cleanup() {
      document.body.className = ""
    }
  }, [])
  const error = null

  return (
    <Row className="g-0">
      <Col lg={12}>
        <div className="text-center">
          <Link to="/" className="mb-3 d-block auth-logo mt-5 mt-md-5 mt-lg-5 ">
            <img src={logo} alt="" height="80" className="logo logo-light" />
            <img src={logoLg} alt="" height="80" className="logo logo-dark" />
          </Link>
        </div>
      </Col>

      <Col xs="12" lg="12">
        <div className="text-center ">
          <h5 className="text-primary text-uppercase">Create an Account</h5>
          <p className="text-muted">Enter your detail below to get started.</p>
        </div>
        <div className="px-2 ">
          <Form
            className="form-horizontal"
            onSubmit={e => {
              e.preventDefault()
              validation.handleSubmit()
              return false
            }}
          >
            {error ? <Alert color="danger">{error}</Alert> : null}

            <div className="mb-3">
              <Input
                autoComplete="off"
                name="firstName"
                className="form-control"
                placeholder="Enter your first name"
                type="firstName"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                value={validation.values.firstName || ""}
                invalid={
                  validation.touched.firstName && validation.errors.firstName
                    ? true
                    : false
                }
              />
              {validation.touched.firstName && validation.errors.firstName ? (
                <FormFeedback type="invalid">
                  {validation.errors.firstName}
                </FormFeedback>
              ) : null}
            </div>
            <div className="mb-3">
              <Input
                autoComplete="off"
                name="lastName"
                className="form-control"
                placeholder="Enter your last name"
                type="lastName"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                value={validation.values.lastName || ""}
                invalid={
                  validation.touched.lastName && validation.errors.lastName
                    ? true
                    : false
                }
              />
              {validation.touched.lastName && validation.errors.lastName ? (
                <FormFeedback type="invalid">
                  {validation.errors.lastName}
                </FormFeedback>
              ) : null}
            </div>
            <div className="mb-3">
              {/* <Label className="form-label">Email</Label> */}
              <Input
                autoComplete="off"
                name="email"
                className="form-control"
                placeholder="Username/Email"
                type="email"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                value={validation.values.email || ""}
                invalid={
                  validation.touched.email && validation.errors.email
                    ? true
                    : false
                }
              />
              {validation.touched.email && validation.errors.email ? (
                <FormFeedback type="invalid text-capitalize">
                  {validation.errors.email}
                </FormFeedback>
              ) : null}
            </div>

            <div className="mb-3">
              {/* <Label className="form-label">Password</Label> */}
              <Input
                autoComplete="off"
                name="password"
                value={validation.values.password || ""}
                type="password"
                placeholder="Enter Your Password"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                invalid={
                  validation.touched.password && validation.errors.password
                    ? true
                    : false
                }
              />
              {validation.touched.password && validation.errors.password ? (
                <FormFeedback type="invalid">
                  {validation.errors.password}
                </FormFeedback>
              ) : null}
            </div>

            <div className="mt-3">
              <button
                className="btn btn-primary w-100 waves-effect waves-light"
                type="submit"
              >
                Register Account
              </button>
            </div>

            <div className="mt-3 text-center">
              <p>
                Already have an account?
                <Link to="/login">
                  <i>
                    <strong>Login</strong>
                  </i>
                </Link>{" "}
              </p>
            </div>
          </Form>
        </div>
      </Col>
    </Row>
  )
}
export default withRouter(Register)

Register.propTypes = {
  registerUser: PropTypes.func,
  // registerUserFailed: PropTypes.func,
  registrationError: PropTypes.any,
  user: PropTypes.any,
}
